'use strict';

const Request = require('../rlink-data-connector/Request');

module.exports = function makeRequest (type, requestName, options = {}, ...argSpec) {
  return new Request(type, requestName, options, argSpec);
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/makeRequest.js